module.exports = __webpack_public_path__ + "images/uphold@2x.490162c7c255dc2edead3fbf901de013.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/logos/uphold@2x.png
// module id = 1021
// module chunks = 0